import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import ProjectSondages from "./ProjectSondages";
import Admin from "./Admin";
import LoginPage from "./LoginPage";
import AuthRoute from "./AuthRoute";
import SearchPage from "./SearchPage";
import ManageSondages from "./ManageSondages";
import FsAdminPage from "./FsAdminPage";
import Graphs from "./Graphs";
import ExcelGenerationList from "./ExcelGenerationsList";

const root = ReactDOM.createRoot(document.getElementById("root"));
export let zoomKey = "zoomScale";
export let depthsKey = "depthsVisibility";
export let descriptionsKey = "descriptionsVisibility";
export let sidePaneVisibilityKey = "sidePaneVisibility";
export let sidePane2VisibilityKey = "sidePane2Visibility";

// if URL not defined, will use the port.
export let API_PORT = process.env.REACT_APP_MYBACKENDAPIPORT; // 5001
export let API_URL = process.env.REACT_APP_MYBACKENDAPIURL; // http://localhost:5001

// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
// );

root.render(
    <Router>
        <Routes>
            <Route path="/login" element={<LoginPage/>}/>

            <Route
                path="/"
                element={
                    <AuthRoute>
                        <App/>
                    </AuthRoute>
                }
            />
            <Route
                path="/graphs"
                element={
                    <AuthRoute>
                        <Graphs/>
                    </AuthRoute>
                }
            />
            <Route
                path="/all-sondages"
                element={
                    <AuthRoute>
                        <ManageSondages/>
                    </AuthRoute>
                }
            />
            <Route
                path="/all-sondages/:pageNbr"
                element={
                    <AuthRoute>
                        <ManageSondages/>
                    </AuthRoute>
                }
            />
            <Route
                path="/:projectName"
                element={
                    <AuthRoute>
                        <App/>
                    </AuthRoute>
                }
            />
            <Route
                path="/:projectName/project/:pageNbr"
                element={
                    <AuthRoute>
                        <App/>
                    </AuthRoute>
                }
            />
            <Route
                path="/:projectName/sondage/:sondageId/docnbr/:docNumber"
                element={
                    <AuthRoute>
                        <App/>
                    </AuthRoute>
                }
            />
            <Route
                path="/search"
                element={
                    <AuthRoute>
                        <SearchPage/>
                    </AuthRoute>
                }
            />

            <Route
                path="/admin"
                element={
                    <AuthRoute>
                        <Admin/>
                    </AuthRoute>
                }
            />
            <Route
                path={"/admin/fs"}
                element={
                    <AuthRoute>
                        <FsAdminPage/>
                    </AuthRoute>
                }
            />
            <Route
                path={"/download-center"}
                element={
                    <AuthRoute>
                        <ExcelGenerationList/>
                    </AuthRoute>
                }
            />
        </Routes>
    </Router>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
